<template>
<div class="h-screen flex w-full bg-img-custom">
    <div class="vx-col w-full mx-auto mt-20">
        <div class="flex flex-wrap mb-4 mx-auto mb-base self-center">
            <img src="@/assets/images/logowhite.png" class="mx-auto max-w-full" width="300" />
        </div>
        <div class="flex flex-wrap mb-4 mx-auto">
            <div class="mx-auto w-full sm:w-3/4 md:w-2/3 lg:w-1/3 xl:w-1/4 mb-4 px-2">
                <vx-card class="text-center">
                    <div slot="no-body">
                        <img src="@/assets/images/pages/login.png" alt="content-img" class="responsive card-img-top">
                    </div>
                    <h2 class="m-10">Smartek</h2>
                    <p class="text-dark mb-base">Please wait while we log you out...</p>
                </vx-card>
            </div>
        </div>
    </div>
</div>
</template>

<script>
export default {
    async created() {

        var cookies = document.cookie.split(";");
        for (var i = 0; i < cookies.length; i++) {
            var cookie = cookies[i];
            var eqPos = cookie.indexOf("=");
            var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
            document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
        }

        //force remove from session storage
        for (var obj in sessionStorage) {
            sessionStorage.removeItem(obj);
        }
        this.$store.dispatch("setIsProgressing", true);
        this.$store.dispatch("logout");
    }
}
</script>
